import { Safety } from '../classes/Safety'

/**
 * Select a label matching the range given in the mapping.
 */
export function choose(options: Record<string, [number, number]>, value: number): string | undefined {
  for (const label in options) {
    if (value >= options[label][0] && value < options[label][1]) {
      return label
    }
  }
}

/**
 * Check if the given debug flag is turned on.
 */
export function isDebug(section: string): boolean {
  const debug: Record<string, boolean> = Safety.get('debug', {})

  return !!debug[section]
}

/**
 * Set caret position.
 */
export function setCaretPosition(elemId: string, caretPos: number) {
  const el = document.getElementById(elemId) as HTMLInputElement & {createTextRange?(): Range;}

  // eslint-disable-next-line no-self-assign
  el.value = el.value
  // ^ this is used to not only get "focus", but
  // to make sure we don't have it everything -selected-
  // (it causes an issue in chrome, and having it doesn't hurt any other browser)

  if (el !== null) {
    if (el.createTextRange) {
      const range = el.createTextRange() as any
      range.move('character', caretPos)
      range.select()
    } else {
      // (el.selectionStart === 0 added for Firefox bug)
      if (el.selectionStart || el.selectionStart === 0) {
        el.focus()
        el.setSelectionRange(caretPos, caretPos)
      } else {
        el.focus()
      }
    }
  }
}
